import { useEffect, useState } from "react";
import { subscribeTestimonials } from "../data/firestore";

export default function useTestimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = subscribeTestimonials((data) => {
      setTestimonials(data);
      setLoading(false);
    });
    return unsub;
  }, []);

  return { testimonials, loading };
}
